<template>
  <update-business-member-field
    title="Date of Birth"
    :value="formattedDob"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-date-picker placeholder="Select date of birth" v-model="dob" required />
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";
import moment from "moment";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dob: "",
    };
  },
  computed: {
    formattedDob() {
      return this.member.dob ? moment(this.member.dob).format("M/D/YYYY") : "-";
    },
  },
  methods: {
    handleIsEditing($event) {
      this.dob = this.member.dob;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        dob: this.dob,
      });
    },
  },
};
</script>
